export const IDLE_DEFAULT_MS = 10 * 60 * 1000;
export const WARN_DEFAULT_MS = 2 * 60 * 1000;

export function getIdleConfig(pathname) {
  // ajuste conforme suas rotas, seguir o modelo para adicionar rotas novas
  if (pathname.startsWith("/envio"))     return { idleMs: 30 * 60 * 1000, warnMs: 5 * 60 * 1000 };

  // caso contrario mantenha o padrao
  return { idleMs: IDLE_DEFAULT_MS, warnMs: WARN_DEFAULT_MS };
}
